// src/pages/LoginForm.jsx

import React, { useEffect, useState } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { postLogin } from "../helpers/rutaLogin";
import "../css/loginform.css";

const LoginForm = () => {
  const history = useHistory();

  const [formValues, setFormValues] = useState({
    email: "",
    password: "",
  });

  const [user, setUser] = useState({
    data: { ok: null },
    loading: false,
  });

  const [isLoggedIn, setIsLoggedIn] = useState(
    !!localStorage.getItem("token")
  );

  useEffect(() => {
    if (user.data.ok) {
      localStorage.setItem("token", user.data.token);
      localStorage.setItem("id", user.data.usuario._id);
      localStorage.setItem(
        "usuario",
        JSON.stringify(user.data.usuario.nombres)
      );

      setIsLoggedIn(true);
      history.push("/");
    }
  }, [user, history]);

  const logout = () => {
    localStorage.clear();
    setIsLoggedIn(false);
    history.push("/login");
  };

  const resetTimer = () => {
    clearTimeout(window.inactivityTimeout);
    window.inactivityTimeout = setTimeout(logout, 60 * 100000);
  };

  useEffect(() => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);

    return () => {
      window.removeEventListener("mousemove", resetTimer);
      window.removeEventListener("keydown", resetTimer);
      clearTimeout(window.inactivityTimeout);
    };
  }, []);

  const handleChange = (e) =>
    setFormValues({ ...formValues, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    setUser((u) => ({ ...u, loading: true }));

    postLogin(formValues).then((datos) => setUser(datos));

    setFormValues({
      email: "",
      password: "",
    });
  };

  if (isLoggedIn) {
    return <Redirect to="/" />;
  }

  return (
    <main className="login-container">
      <section className="login-box">
        <div className="login-header">
          <h2 className="login-title">APP RIDERS MIAMI</h2>
          <h2 className="login-subtitle">SISTEMA DE GESTIÓN</h2>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-field">
            <label htmlFor="email">Correo electrónico</label>
            <input
              id="email"
              type="email"
              className="form-control login-input"
              name="email"
              value={formValues.email}
              onChange={handleChange}
              required
              autoFocus
            />
          </div>

          <div className="login-field">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              className="form-control login-input"
              name="password"
              value={formValues.password}
              onChange={handleChange}
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-dark w-100 btn-login-riders"
            disabled={user.loading}
          >
            {user.loading ? "Validando..." : "Iniciar sesión"}
          </button>
        </form>

        {user.data.ok === false && (
          <div className="alert alert-danger text-center login-alert">
            {user.data.err?.message || "Error al iniciar sesión"}
          </div>
        )}
      </section>
    </main>
  );
};

export default LoginForm;